import { useState, useEffect } from 'react';

export default function ProblemSection() {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    if (document.fonts) {
      document.fonts.ready.then(() => {
        setFontsLoaded(true);
      });
    } else {
      setFontsLoaded(true);
    }
  }, []);

  const fontFamily = fontsLoaded ? 'Montserrat, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';
  const fontFamilyInter = fontsLoaded ? 'Inter, sans-serif' : '-apple-system, BlinkMacSystemFont, sans-serif';

  return (
    <section className="relative py-16 sm:py-32 bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-16 items-center">
          {/* Conteúdo */}
          <div className="space-y-6 sm:space-y-8">
            <div className="inline-block">
              <span className="text-yellow-400 text-xs sm:text-sm font-bold tracking-widest uppercase" style={{ fontFamily }}>
                O PROBLEMA INVISÍVEL
              </span>
              <div className="h-1 w-16 sm:w-20 bg-gradient-to-r from-yellow-400 to-transparent mt-2" />
            </div>
            
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black leading-tight" style={{ fontFamily }}>
              Você sente que nasceu para <span className="bg-gradient-to-r from-yellow-400 to-yellow-600 bg-clip-text text-transparent">mais</span>,<br className="hidden sm:block" />
              mas algo te impede de prosperar?
            </h2>
            
            <div className="space-y-4 sm:space-y-6 text-base sm:text-lg md:text-xl text-gray-300 leading-relaxed" style={{ fontFamily: fontFamilyInter }}>
              <p className="flex items-start gap-3 sm:gap-4">
                <i className="ri-error-warning-line text-yellow-400 text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <span>A maioria das pessoas não é pobre por falta de esforço, e sim por <strong className="text-yellow-400 font-semibold">bloqueios mentais invisíveis</strong>.</span>
              </p>
              
              <p className="flex items-start gap-3 sm:gap-4">
                <i className="ri-brain-line text-yellow-400 text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <span>O verdadeiro inimigo não está no mundo — <strong className="text-yellow-400 font-semibold">está dentro da mente</strong>.</span>
              </p>
              
              <p className="flex items-start gap-3 sm:gap-4">
                <i className="ri-lock-line text-yellow-400 text-xl sm:text-2xl mt-1 flex-shrink-0"></i>
                <span>Enquanto você busca soluções externas, suas crenças internas sabotam sua prosperidade.</span>
              </p>
              
              <div className="bg-gradient-to-r from-yellow-500/10 to-transparent border-l-4 border-yellow-500 p-4 sm:p-6 rounded-r-lg mt-6 sm:mt-8">
                <p className="text-yellow-400 font-bold text-lg sm:text-xl" style={{ fontFamily }}>
                  O primeiro passo para mudar de vida é mudar o código da sua mente.
                </p>
              </div>
            </div>
          </div>
          
          {/* Imagem - apenas desktop */}
          <div className="relative hidden lg:flex justify-end">
            <div className="relative w-full max-w-lg">
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-500/20 to-transparent rounded-3xl blur-3xl" />
              <img 
                src="https://readdy.ai/api/search-image?query=premium%20golden%20glowing%20brain%20with%20bright%20neural%20networks%20and%20energy%20particles%2C%20luxury%20mental%20transformation%20concept%2C%20dark%20elegant%20background%20with%20brilliant%20golden%20light%20rays%20and%20diamond%20sparkles%2C%20cinematic%20lighting&width=600&height=600&seq=mind-premium&orientation=squarish"
                alt="Mente dourada brilhando com energia"
                className="relative w-full rounded-3xl shadow-2xl shadow-yellow-500/30 border border-yellow-500/20"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
